<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';

	export let testConfetti;

	const handleTestConfetti = () => {
		testConfetti = true;

		setTimeout(() => {
			testConfetti = false;
		}, 2000);
	};
</script>

<IconButton disable={testConfetti} class="mr-s" icon="fas fa-envelope" on:click={handleTestConfetti}
	>Test Confetti</IconButton
>
